/**
 * 异步请求模块
 * @param  {String} url     请求地址
 * @param  {Object} data    发送数据
 * @param  {Function} success 成功回调
 * @param  {Function} error   失败回调
 * @param  {String} type    请求类型
 * @return {Null}         无返回
 */

const ajaxFn = (paremsConfig) => {
    const baseConfig = Object.assign({
        url: '',
        type: 'GET',
        data: {},
        dataType: 'JSON',
        success: null,
        error: null,
        complete: null,
        timeout: 5000
    }, paremsConfig);

    // 参数判断
    if (baseConfig.url === '') {
        return;
    }
    if (baseConfig.success && (typeof baseConfig.success !== 'function')) {
        return;
    }
    if (baseConfig.error && (typeof baseConfig.error !== 'function')) {
        return;
    }
    if (baseConfig.complete && (typeof baseConfig.complete !== 'function')) {
        return;
    }

    $.ajax({
        url: baseConfig.url,
        type: baseConfig.type,
        data: baseConfig.data || {},
        dataType: baseConfig.dataType,
        success: (res) => {
            if (!res) {
                return;
            }

            if (baseConfig.success && typeof baseConfig.success === 'function') {
                baseConfig.success(res);
            }
        },
        error: () => {
            if (baseConfig.error && typeof baseConfig.error === 'function') {
                baseConfig.error();
            }
        },
        complete: () => {
            if (baseConfig.complete && typeof baseConfig.complete === 'function') {
                baseConfig.complete();
            }
        }
    });
};

export default ajaxFn;
